var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('shop-breadcrumb',{staticStyle:{"margin":"0 auto","width":"1200px"},attrs:{"breadcrumbList":_vm.breadcrumbList,"skip":true}}),_c('div',{staticClass:"docx"},[_c(_vm.switchComponent,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }